export class WellsListFilterModel {
  public Apinumber: string = "";
  public Uicnumber: string = "";
  public LeaseName: string = "";
  public WellNumber: string = "";
  public OperatorOperatorName: string = "";
  public ExcludeZeroInjections: Boolean = false;
  public ShowFavorites: Boolean = false;
}
